import { DemoEnrollForm } from '@/components/demo/DemoEnrollForm';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { isDemoModeEnabled } from '@/lib/demo';
import { createFileRoute, notFound } from '@tanstack/react-router';
import { QrCode } from 'lucide-react';

export const Route = createFileRoute('/demo/enroll')({
  beforeLoad: () => {
    if (!isDemoModeEnabled()) {
      throw notFound();
    }
  },
  component: DemoEnrollPage,
});

function DemoEnrollPage() {
  return (
    <main className="flex min-h-screen flex-col items-center justify-center gap-6 bg-background p-4">
      <div className="flex items-center gap-2">
        <QrCode className="h-8 w-8 text-primary" />
        <h1 className="text-2xl font-bold tracking-tight">Inscripción demo</h1>
      </div>
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>Inscríbete al evento demo</CardTitle>
          <CardDescription>
            Recibirás un correo con tu QR y código corto para usarlos en vivo durante la demo.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <DemoEnrollForm />
        </CardContent>
      </Card>
    </main>
  );
}
